export type AnyVanLocale = "en" | "es" | "us" | "fr" | "de"


type Region = 'UK' | 'ES' | 'US' | 'FR' | 'DE'

export const LOCALE: Record<Region, AnyVanLocale> = {
  UK: "en",
  US: "us",
  ES: "es",
  FR: "fr",
  DE: "de",
} as const

export type PlacesLocale = "GB" | "ES" | "US" | "FR" | "DE" | ""

export const PLACES_LOCALE: Record<Region, PlacesLocale> = {
  UK: "GB",
  US: "US",
  ES: "ES",
  FR: "FR",
  DE: "DE",
} as const

export const LOCALE_TO_PLACES_LOCALE: Record<AnyVanLocale, PlacesLocale> = {
  en: "GB",
  us: "US",
  es: "ES",
  fr: "FR",
  de: "DE",
}
